module.exports = __webpack_public_path__ + "img/buildings.5a7f562.svg";